<div class="world_image px-4 py-3">
  <h2 class="headingBL text-center">About <span> Us </span></h2>
  <div class="d-flex justify-content-around align-items-center gap-5 wrapper">
    <div class="detail_wrapper">
      <h4 class="title">Virsa provides skills that last for a lifetime!</h4>
      <p class="detailText mt-3">
        At Virsa, we're driven by a deep-rooted passion for the performing arts
        and the preservation of cultural heritage. Our name, "Virsa," derived
        from "Virasat" (heritage), embodies our mission to reconnect individuals
        with their roots and offer a gateway to a more fulfilling life through
        the performing arts. We offer a diverse array of meticulously crafted
        courses, led by experienced maestros, which empower learners of all
        levels to explore, learn, and celebrate the rich tapestry of music,
        dance, and theatre. Beyond our online courses, we extend our commitment
        to cultural enrichment through programs like "Virsa at School," "Connect
        with Legend," "Become a Professional," and "Trainer at Your Doorstep."
        At Virsa, we invite you to embark on a journey that transcends the
        boundaries of tradition and modernity, and where the beauty of
        performing arts enriches lives. Join us and let Virsa be your path to
        discovering, nurturing, and mastering the art forms that define our
        heritage.
      </p>
    </div>
    <div style="width: 100%; height: 100%; overflow: hidden">
      <div id="chart">
        <div style="text-align: right" class="fs-6 mb-2 headingBS">
          Reach of <span>Our virsa</span> and its <span>associate</span>
        </div>
        <apx-chart
          [series]="chartOptions.series"
          [chart]="chartOptions.chart"
          [plotOptions]="chartOptions.plotOptions"
          [labels]="chartOptions.labels"
          [colors]="chartOptions.colors"
          [responsive]="chartOptions.responsive"
        ></apx-chart>
      </div>
    </div>
  </div>
</div>
